export const SHOULD_BLOCK_TRANSITION = 'SHOULD_BLOCK_TRANSITION'
